import * as Yup from "yup";

export const tenantUpdateRequestSchema = Yup.object({
  allowedEmails: Yup.array().of(Yup.string().required()).required(),
});

export type TenantUpdateRequest = Yup.InferType<
  typeof tenantUpdateRequestSchema
>;
